import React, { useState } from "react";
import styles from "./MammalChampion.module.scss";
import JoinComponent from "./JoinComponent";
import { Link } from "@reach/router";
import Username from "./Username";

function GeographyChampion(props) {
  const [geogNo, setGeogNo] = React.useState(0);

  if (geogNo === 0) {
    return (
      <div className={styles.bkg}>
        <p>
          Yeah, you probabbly recognise me from Insta, it’s me, the River
          Mersey. Humans always want a picture with me, maybe that's why I’m the
          Champion of the Natural Features Folk. We’re the people you humans
          take completely for granted, the rivers, hills, rocks, streams and
          beaches that make up Liverpool. Can you imagine Liverpool without me
          the Mersey? Or without the hills up to Hope Street or Everton Brow?
          Some people say Liverpool is one big hill by the River,
        </p>
        <p>
          {" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(1);
            }}
          >
            Can you think of any more natural features around here?
          </button>{" "}
        </p>

        <JoinComponent folk={props.type} alpha={props.alpha} />
      </div>
    );
  }
  if (geogNo === 1) {
    return (
      <div className={styles.bkg}>
        <p>
          Look around and you will feel streams running below your feet, you'll
          see ponds, lakes, rocks and quarries, forests and out there the sea.
          You probably take us for granted, but we are the landscape this city
          is built on, we support it and shape it in ways that most people don't
          ever realise. Do you worry that humans aren’t treating rivers, beaches
          and the earth below your feet in the way that you should?
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(2);
            }}
          >
            Yes, I worry about the Liverpool landscape sometimes.
          </button>{" "}
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(8);
            }}
          >
            No, I don't even think about the Liverpool landscape.
          </button>{" "}
        </p>
      </div>
    );
  }
  if (geogNo === 2) {
    return (
      <div className={styles.bkg}>
        <p>Are you a bit up and down sometimes, like my tides?</p>
        <p>
          {" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(3);
            }}
          >
            I am up and down like the tides of the Mersey.
          </button>
        </p>
        <p>
          {" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(7);
            }}
          >
            I'm always on a pretty even keel to be honest
          </button>
        </p>
      </div>
    );
  }
  if (geogNo === 3) {
    return (
      <div className={styles.bkg}>
        <p>
          Do you like the idea of taking a break from your phone and thinking on
          a longer time scale?
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(4);
            }}
          >
            Yes I'd like to think more about the distant past and the faraway
            future.
          </button>{" "}
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setGeogNo(6);
            }}
          >
            No, I just care about right now.
          </button>{" "}
        </p>
      </div>
    );
  }
  if (geogNo === 4) {
    return (
      <div className={styles.bkg}>
        <p>
          Join us, the Natural feature Folk! Help give us a voice by placing
          incident report markers on this map and winning the game!
        </p>

        <Link className={styles.choice} to={"/" + props.type + ""}>
          Join as one of the Natural Feature folk
        </Link>
      </div>
    );
  }

  if (geogNo === 6) {
    return (
      <div className={styles.bkg}>
        <p>Maybe you're more of a mammal kind of person.</p>
      </div>
    );
  }
  if (geogNo === 7) {
    return (
      <div className={styles.bkg}>
        <p>Maybe you're more of a plant kind of person - go talk with them.</p>
      </div>
    );
  }
  if (geogNo === 8) {
    return (
      <div className={styles.bkg}>
        <p>Maybe you're more of an insect? Go talk to them.</p>
      </div>
    );
  }
}

export default GeographyChampion;
